import Image from "next/image";
import classes from "./BlogCarouselItem.module.css";
import Link from "next/link";

const BlogCarouselItem = ({ listing, idx }) => {
  return (
    <li className={classes.item} key={idx}>
      <Link
        href={`/product/${listing.kashewId}`}
        className={classes.productLink}
      >
        <section className={classes.topSection}>
          <Image
            src={listing.images[0]}
            alt={listing.title}
            width={200}
            height={200}
            className={classes.img}
          />
        </section>

        <section className={classes.bottomSection}>
          <h3 className={classes.title}>{listing.title}</h3>
          <section className={classes.infoSection}>
            {listing?.estRetailPrice &&
            listing?.estRetailPrice > listing.price ? (
              <span className={`${classes.priceRed}`}>
                ${listing.price.toLocaleString()}
              </span>
            ) : (
              <span className={`${classes.price}`}>
                ${listing.price.toLocaleString()}
              </span>
            )}
            {listing.estRetailPrice &&
              listing.estRetailPrice > listing.price && (
                <span className={`${classes.retailPrice}`}>
                  ${listing.estRetailPrice.toLocaleString()}
                </span>
              )}
            {!listing.priceIsFirm && (
              <div className={classes.negotiable}>Negotiable</div>
            )}
          </section>
        </section>
      </Link>
    </li>
  );
};

export default BlogCarouselItem;
